<template>
  <div>
    <b-sidebar
      id="addtile"
      width="320px"
      right
      shadow
      text-variant="light"
      :title="title"
      v-model="show"
      class="addtile"
    >
      <b-card>
        <b-card-sub-title>Tile Gallery</b-card-sub-title>
        <b-input-group class="mt-3">
          <b-form-input size="sm" placeholder="Search Tiles"></b-form-input>
          <b-input-group-append>
            <b-button size="sm" @click="filter = ''">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-card-text class="mt-2">{{items.length}} tiles</b-card-text>
        <hr />
        <b-list-group flush class="mb-4">
          <b-list-group-item class="pt-2 pb-0" v-for="(item,index) in items" :key="index">
            <b-row>
              <b-col>
                <i :class="item.icon+' text-primary pr-2'"></i>{{item.component}}
              </b-col>
              <b-col cols="3">
                <b-button variant="link" size="sm">Add</b-button>
              </b-col>
            </b-row>
          </b-list-group-item>       
        </b-list-group>
        <b-row>
          <b-col class="ml-3">
            <b-button variant="outline-primary" size="sm" squared @click="show=false">OK</b-button>
            <b-button variant="outline-secondary" class="ml-2" size="sm" squared @click="show=false">Cancel</b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "Addtiles",
  data() {
    return {
      title: "Add Dashboard Tiles",
      items: [],
      show: false,
      busy: false
    };
  },
  watch: {
    show: {
      async handler(newVal, oldVal) {
        console.log("watch:show", newVal);
        if (newVal) {
          await this.loadData();
        }
      }
    }
  },
  methods: {
    async loadData() {
      this.busy = true;
      let variables = { 
        category: "dashboardtiles.general" 
      };
      let response = await this.$apollo.query({
        query: gql`
          query setup_systemsettings($category: String) {
            setup_systemsettings(category: $category) {
              data
            }
          }
        `,
        variables
      });
     this.items = [];
      for (var i = 0; i < response.data.setup_systemsettings.length; i++) {
        let obj = JSON.parse(response.data.setup_systemsettings[i].data)
        this.items.push(obj[0])
      }
      this.busy = false;
    },
  }
};
</script>

<style>
</style>